import React from 'react';
import ComparisonCategory from '@/types/comparison-category';

interface Props {
  category: ComparisonCategory;
  onTabSelectionChange: (categoryKey: string, value: number) => void;
  selectedValue?: number;
  tooltip?: React.ReactNode;
}

const ComparisonCategoryHeader: React.FC<Props> = ({ category, onTabSelectionChange, selectedValue, tooltip }) => {
  if (!category.dynamicConfig || category.dynamicConfig.type !== 'multi-tab-select') {
    return <div className="comparison-category-header">{category.label}</div>;
  }

  const { options, defaultValue } = category.dynamicConfig;
  const currentValue = selectedValue || defaultValue;

  return (
    <div className="comparison-category-header">
      <div className="category-title">
        {category.label}
        {tooltip && tooltip}
      </div>
      <div className="tab-selector">
        {options.map(option => (
          <button
            key={option.value}
            className={`tab ${currentValue === option.value ? 'active' : ''}`}
            onClick={() => onTabSelectionChange(category.key, option.value)}
            type="button"
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ComparisonCategoryHeader;
